module.exports = __webpack_public_path__ + "img/gift.a6ffb729.svg";